export default () => {
  var $contestWorkForm, ContestWorkForm, contestWorkForm, forceDestroy;
  $contestWorkForm = $('.js-contest-work');
  if ($contestWorkForm.length === 0) {
    return;
  }
  ContestWorkForm = Backbone.View.extend({
    el: $contestWorkForm,
    crop_square_side_size: 250,
    events: {
      'keyup .js-contest-work-title': 'checkTextTitleLimit'
    },
    initialize: function() {
      var self;
      this.checkTextTitleLimit();
      this.initCropper();
      this.licenseValidate();
      self = this;
      $('#workUpload').fileupload({
        url: Routes.contest_work_images_path(),
        type: 'POST',
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        formData: [],
        done: function(e, data) {
          var response;
          response = data.result;
          if (response.error) {
            showError(response.error);
          } else {
            self.workImageWrapper().find('img').attr('src', response.preview_url);
            self.workUploadWrapper().hide();
            self.workImageWrapper().css('display', 'flex');
            self.workCacheInput().val(response.cache);
            self.removeWorkInput().val(0);
            $('#image-cropper').cropper('replace', response.preview_url);
          }
        },
        fail: function() {
          return showError(I18n.t('server_error'));
        }
      });
    },
    checkTextTitleLimit: function() {
      var $title;
      $title = $('.js-contest-work-title');
      if ($title.val().length >= 60) {
        return $title.addClass('red');
      } else {
        return $title.removeClass('red');
      }
    },
    licenseValidate: function() {
      var $license, $license_input;
      $license = $('#contest_work_license');
      $license_input = $('#contest_work_license_input');
      $('.checkbox__input').on('click', function () {
        if($(this).is(':checked')) {
          $license_input.removeClass('checkbox__error');
        } else {
          $license_input.addClass('checkbox__error');
        }
      })
      if ($license.hasClass('error')) {
        return $license_input.addClass('checkbox__error');
      }
    },
    initCropper: function() {
      $('#image-cropper').cropper({
        aspectRatio: 1/1,
        // autoCropArea: 1,
        background: false,
        zoomable: false,
        rotatable: true,
        autoCrop: true,
        cropBoxMovable: true,
        cropBoxResizable: true,
        // minCropBoxWidth: this.crop_square_side_size,
        // minCropBoxHeight: this.crop_square_side_size,
        data: this.getCropData()
      });
    },
    saveCropperData: function(e) {
      return this.setCropData($('#image-cropper').cropper('getData'));
    },
    getCropData: function() {
      return JSON.parse(this.cropDataInput().val());
    },
    setCropData: function(value) {
      return this.cropDataInput().val(JSON.stringify(value));
    },
    cropDataInput: function() {
      return this.$el.find('[name*="crop_data"]');
    },
    clearWorkImage: function() {
      this.workCacheInput().val('');
      this.removeWorkInput().val(1);
      this.workImageWrapper().find('img').removeAttr('src');
      this.workImageWrapper().hide();
      return this.workUploadWrapper().show();
    },
    workCacheInput: function() {
      return this.$el.find('[name*="image_cache"]');
    },
    removeWorkInput: function() {
      return this.$el.find('[name*="remove_image"]');
    },
    workImageWrapper: function() {
      return $('#workImageWrapper');
    },
    workUploadWrapper: function() {
      return $('#workUploadWrapper');
    },
    submit: function() {
      this.saveCropperData();
      return this.$el.submit();
    }
  });
  contestWorkForm = new ContestWorkForm();
  forceDestroy = false;
  $('#deleteWorkImage').click(function() {
    var self;
    if (!forceDestroy) {
      self = $(this);
      showQuestion(I18n.t('illustration_destruction_confirmation'), function() {
        forceDestroy = true;
        return $.ajax({
          url: self.attr('href'),
          method: 'POST',
          data: {
            _method: 'delete'
          }
        }).done(function(data) {
          return window.location = data.location;
        });
      });
      return false;
    } else {
      return true;
    }
  });
  // $('#reloadWorkImage').click(function() {
  //   return $('#workUpload').trigger('click');
  // });
  return $('#submitContestWork').click(function() {
    return contestWorkForm.submit();
  });
}